import { jsx } from 'react/jsx-runtime';
import '../../../utils/index_orig/index.esm.js';
import '../../../utils/theme/theme-provider/index.esm.js';
import styles from '../../../styles/uitk-egds-expando.css';
import { classNames } from '../../../utils/classnames/index.esm.js';
const getClassNameList = classNames.bind(styles);
/**
 * This is a simple expander that when clicked, will show more text or other
 * children. Makes use of inversion of control.
 * We make use of a description list:
 *
 * @see {@link https://developer.mozilla.org/en-US/docs/Web/HTML/Element/dl}
 * Accessibility:
 * @see {@link http://wwwexpediacom.a11y-demos-web.us-west-2.test.expedia.com/pages/components/toggles}
 */
const EGDSExpandoList = ({
  children,
  className,
  ...props
}) => {
  const cssClassNames = getClassNameList('uitk-expando-list', className);
  return jsx("section", {
    className: cssClassNames,
    ...props,
    children: children
  });
};
EGDSExpandoList.displayName = 'EGDSExpandoList';
export { EGDSExpandoList };